import React, { useEffect, useState } from 'react';
import './App.css';
import Dashboard from './pages/Dashboard';
import DiskErasure from './pages/DiskErasure';
import ActivityLog from './pages/ActivityLog';
import Layout from './components/common/Layout';
import DriveDetails from './pages/DriveDetails';
import FileExplorer from './pages/FileExplorer';
import Encryption from './pages/Encryption';
import Users from './pages/Users';
import Companies from './pages/Companies';
import Departments from './pages/Departments';
import License from './pages/License'
import Login from './pages/Login';
import AuthContext from './AuthContext';
import ProtectedWrapper from './ProtectedWrapper';
import { createBrowserRouter, createRoutesFromElements, RouterProvider, Route } from 'react-router-dom';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState('');
  const [user, setUser] = useState('');
  const [userType, setUserType] = useState('');
  const [token, setToken] = useState('');
  const [admin, setAdmin] = useState('');

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      setUsername(user.name);
      setIsLoggedIn(true);
      setUser(user.id);
      setUserType(user.user_type);
      setAdmin(user.company_id);
      setToken(user.token);
    }
  }, []);
  const signin = (newUser, callback) => {
    if (newUser && newUser.name) {
      localStorage.setItem('user', JSON.stringify(newUser));
      setUsername(newUser.username);
      setIsLoggedIn(true);
      setUser(newUser.id);
      setUserType(newUser.user_type);
      setAdmin(newUser.company_id);
      setToken(newUser.token);
      if (callback) callback();
    }
  };

  const signout = () => {
    localStorage.removeItem('user'); // Fixed typo: 'User' to 'user'
    setUsername('');
    setUser('');
    setIsLoggedIn(false);
    setUserType('');
    setAdmin('');
    setToken('');
  };

  const value = { username, user, userType, admin, isLoggedIn, token, signin, signout };

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />

        {/* Protected Routes under Layout */}
          <Route path="/" element={
              <ProtectedWrapper>
                <Layout/>
              </ProtectedWrapper>
            }>
            <Route index element={<Dashboard />} />
            <Route path="/disk-erasure" element={<DiskErasure />} />
            <Route path="/activity-log" element={<ActivityLog />} />
            <Route path="/drive-details/:deviceName" element={<DriveDetails />} />
            <Route path="/file-explorer" element={<FileExplorer />} />
            <Route path="/disk-encryption" element={<Encryption />} />
            <Route path="/users" element={<Users />} />
            <Route path="/companies" element={<Companies />} />
            <Route path="/departments" element={<Departments />} />
            <Route path="/license" element={<License/>}/>
            <Route path="*" element={<h1>404 Not Found</h1>} />
          </Route>
      </Route>
    )
  );

  return (
    <AuthContext.Provider value={value}>
      <RouterProvider router={router} />
    </AuthContext.Provider>
  );
}

export default App;